import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import React from 'react';

import styles from './styles.module.scss';

interface MuiToggleProps {
  label: string;
  hideLabel?: boolean;
  required?: boolean;
  options: { value: string; label: string }[];
  selectedValue: string;
  onChange: (value: string) => void;
}

const MuiToggle: React.FC<MuiToggleProps> = ({
  label,
  options,
  hideLabel = false,
  required = true,
  selectedValue,
  onChange,
}) => {
  const handleChange = (_event: React.MouseEvent<HTMLElement>, newValue: string | null): void => {
    if (newValue !== null) {
      onChange(newValue);
    }
  };

  return (
    <div className={styles.toggleContainer}>
      {!hideLabel && (
        <label className={styles.toggleLabel} htmlFor={label}>
          {label} {required && <span className={styles.required}>*</span>}
        </label>
      )}
      <ToggleButtonGroup value={selectedValue} exclusive onChange={handleChange} className={styles.toggleGroup}>
        {options.map((option) => (
          <ToggleButton
            key={option.value}
            value={option.value}
            className={`${styles.toggleButton} ${selectedValue === option.value ? styles.selected : ''}`}
          >
            {option.label}
          </ToggleButton>
        ))}
      </ToggleButtonGroup>
    </div>
  );
};

export default MuiToggle;
